import React from "react";
import { Card, Descriptions } from "antd";
import FieldSwitch from "./FieldSwitch";
import FieldAttivaDisattiva from "./FieldAttivaDisattiva";
import FieldAttivaCentroServizi from "./FieldAttivaCentroServizi";
import FieldAttivaAF from "./FieldAttivaAF";
import FieldActiveStarterPlan from "./FieldActiveStarterPlan";
import FieldMarketplace from "./FieldMarketplace";

const OrgSettings = ({ org }) => {
  return (
    <Card title="Impostazioni" bordered={false}>
      <Descriptions bordered>
        <Descriptions.Item label="Org Attiva" span={2}>
          <FieldAttivaDisattiva org={org} />
        </Descriptions.Item>
        <Descriptions.Item label="Fatturazione Attiva" span={2}>
          <FieldSwitch org={org} property="fatturazione_attiva" />
        </Descriptions.Item>
        <Descriptions.Item label="Fatturazione Passiva" span={2}>
          <FieldSwitch org={org} property="fatturazione_passiva" />
        </Descriptions.Item>
        <Descriptions.Item label="Fattura Ad-Hoc" span={2}>
          <FieldSwitch org={org} property="fattura_adhoc" />
        </Descriptions.Item>
        <Descriptions.Item label="Preventivo Ad-Hoc" span={2}>
          <FieldSwitch org={org} property="preventivo_adhoc" />
        </Descriptions.Item>
        <Descriptions.Item label="Ordine Ad-Hoc" span={2}>
          <FieldSwitch org={org} property="ordine_adhoc" />
        </Descriptions.Item>
        <Descriptions.Item label="Demo OFC Already Done" span={2}>
          <FieldSwitch org={org} property="demo_ofc_already_done" />
        </Descriptions.Item>
        <Descriptions.Item label="Eterno" span={2}>
          <FieldSwitch org={org} property="ofc" />
        </Descriptions.Item>
        <Descriptions.Item label="Giotto" span={2}>
          <FieldSwitch org={org} property="giotto" />
        </Descriptions.Item>
        <Descriptions.Item
          label="Fornitore Centro Prenotazioni"
          span={2}
        >
          {/* <FieldSwitch org={org} property="fornitore_centro_prenotazioni" /> */}
          <FieldAttivaCentroServizi org={org} />
        </Descriptions.Item>
        <Descriptions.Item label="Utilizzatore Prestazioni" span={2}>
          <FieldSwitch org={org} property="utilizzatore_prestazioni" />
        </Descriptions.Item>
        <Descriptions.Item
          label="Integrazione Annunci Funebri"
          span={2}
        >
          {/* <FieldSwitch org={org} property="integrazione_annunci_funebri" /> */}
          <FieldAttivaAF org={org} />
        </Descriptions.Item>
        <Descriptions.Item label="Attiva PIANO PARTNER" span={2}>
          <FieldActiveStarterPlan org={org} />
        </Descriptions.Item>
        <Descriptions.Item label="Marketplace / Sito" span={2}>
          <FieldMarketplace org={org} />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default OrgSettings;